enum MainnetType {
  Ethereum = 'Ethereum',
  BSC = 'BSC',
  BSCTest = 'BSC Test',
}

export default MainnetType
